import { BriefcaseAccountOutlineIcon } from './BriefcaseAccountOutlineIcon';

/**
 * author: Michael Irigoyen
 * id F92EB0E4-257F-4200-A18E-0F0C02C8DB51
 * name briefcase-account-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-account-outline.svg
 * tags
 * - Account / User 
 */
export const BriefcasePersonOutlineIcon = BriefcaseAccountOutlineIcon;
export default BriefcasePersonOutlineIcon